// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Mail, HelpCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function PatientSupport() {
  return (
    <DashboardLayout activePage="/patient-support">
      <div className="space-y-8">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Support Center</h2>
          <p className="text-muted-foreground mt-2">
            Contact us for assistance
          </p>
        </div>

        {/* Contact Information */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Card>
            <CardHeader>
              <CardTitle>Contact Information</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 border rounded-lg hover:bg-muted/50 transition-colors">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                    <Phone className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-lg">Phone Support</p>
                    <a href="tel:+18005551234" className="text-primary hover:underline">
                      +1 773 357 6850
                    </a>
                    <p className="text-sm text-muted-foreground mt-1">
                      Available 24/7 for urgent matters
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-4 border rounded-lg hover:bg-muted/50 transition-colors">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                    <Mail className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-lg">Email Support</p>
                    <a href="mailto:support@anthro.care" className="text-primary hover:underline">
                      support@anthro.care
                    </a>
                    <p className="text-sm text-muted-foreground mt-1">
                      We'll respond within 24 hours
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>

        {/* FAQ Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <HelpCircle className="w-5 h-5" />
                Frequently Asked Questions
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-3">
                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold mb-1">How do I update my contact information?</h4>
                  <p className="text-sm text-muted-foreground">
                    Go to your Profile page and update your information there. Changes are saved automatically.
                  </p>
                </div>
                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold mb-1">How can I view my care plan?</h4>
                  <p className="text-sm text-muted-foreground">
                    Navigate to "My Care Plan" from the dashboard to view your current care plan and goals.
                  </p>
                </div>
                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold mb-1">Who can I contact in case of emergency?</h4>
                  <p className="text-sm text-muted-foreground">
                    For medical emergencies, always call 911. For urgent care questions, contact your assigned care team directly.
                  </p>
                </div>
                <div className="border-l-4 border-primary pl-4">
                  <h4 className="font-semibold mb-1">How do I manage who has access to my information?</h4>
                  <p className="text-sm text-muted-foreground">
                    Visit the "Manage Access" page to control who can view your health information.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </DashboardLayout>
  );
}